import { SkypeNotificationOption } from 'owa-skype-option';
var skypeSubCategory = {
    key: 'skype',
    titleStringKey: 'optionSubcategory_skype',
    options: [SkypeNotificationOption],
};
export default skypeSubCategory;
//# sourceMappingURL=skypeSubCategory.js.map